/**
 * `store.ts` snapshots the whole store into sessionStorage on unload and spreads it back over the
 * initial state on the next load, with no allowlist. Slices that describe what is on screen right
 * now come back with it, so a modal the user closed by reloading reopens itself.
 */
export const TRANSIENT_STATE_KEYS = ['queuePriorityModal', 'verticalNav'];

export const withoutTransientState = <T extends Record<string, any>>(
  state: T
): T => {
  const restored = { ...state } as Record<string, any>;
  TRANSIENT_STATE_KEYS.forEach(key => {
    delete restored[key];
  });
  return restored as T;
};
